// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__AmV3n","header":"PatientBlock_header__2aHUy","label":"PatientBlock_label__iI0gw","option":"PatientBlock_option__2bc6c"};